import { useCallback } from "react";

import * as Repository from "../repository";

import type * as DiscountItemOrdinaryShared from "../../../_shared";

export const useCreateDiscountLongTerm = (
	inputModel: DiscountItemOrdinaryShared.Model.ModelType.DiscountLongTermStayFormModel["InputModel"],
) => {
	const { onCreateDiscountLongTerm: _onCreateDiscountLongTerm } =
		Repository.Mutation.useDiscountLongTermCreateMutation();

	const onCreateDiscountLongTerm = useCallback(
		() => _onCreateDiscountLongTerm(inputModel),
		[_onCreateDiscountLongTerm, inputModel],
	);

	return {
		onCreateDiscountLongTerm,
	};
};
